import { DateTime } from "luxon";

export const getDateTimeFromClickPosition = (
  yPosition: number,
  calendarContainerRef: React.RefObject<HTMLDivElement>,
  dateTimeToRender: DateTime,
) => {
  const top = calendarContainerRef.current?.getBoundingClientRect().top ?? 0 + window.scrollY;
  const height = calendarContainerRef.current?.offsetHeight ?? 0;
  const pxPerBlock = height / 96; // 15 minute blocks
  const clickPosition = yPosition - top;

  const timeBlock = Math.floor(clickPosition / pxPerBlock);

  return dateTimeToRender.startOf("day").plus({ minutes: timeBlock * 15 });
};
